/* eslint-disable eqeqeq */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { Paper } from "@material-ui/core";
import {
  FilteringState,
  GroupingState,
  IntegratedFiltering,
  IntegratedPaging,
  IntegratedSorting,
  PagingState,
  SortingState,
} from "@devexpress/dx-react-grid";
import {
  Grid,
  PagingPanel,
  Table,
  TableFilterRow,
  TableHeaderRow,
} from "@devexpress/dx-react-grid-material-ui";

class R300DiscountVoucherTableComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      columns: [],
      rows: [],
      formatColumns: [],
      currencyColumns: [],
      availableFilterOperations: [
        "equal",
        "notEqual",
        "greaterThan",
        "greaterThanOrEqual",
        "lessThan",
        "lessThanOrEqual",
      ],
      pageSizes: [5, 10, 15, 20],
      defaultSorting: [],
      sortingStateColumnExtensions: [
        { columnName: "action", sortingEnabled: false },
      ],
      tableColumnExtensions: [
        // { columnName: "SRNo", width: 100 },
        // //{ columnName: "ID", width: 100 },
        { columnName: "Category", wordWrapEnabled: true },
        { columnName: "product", wordWrapEnabled: true },
        // { columnName: "action", width: 120 },
      ],
      defaultColumnWidths: [
        // { columnName: "ID", minWidth: 100, maxWidth: 100 },
        // // { columnName: "shortLabel", minWidth: 100, maxWidth: 100 },
        // { columnName: "label", minWidth: 100, maxWidth: 100 },
        // { columnName: "action", minWidth: 100, maxWidth: 100 },
      ],
      resizingMode: "widget",
      defaultFilters: [],
      filteringStateColumnExtensions: [
        { columnName: "action", filteringEnabled: false },
      ],
    };
  }

  render() {
    const {
      tableColumnExtensions,
      defaultSorting,
      sortingStateColumnExtensions,
      filteringStateColumnExtensions,
      defaultFilters,
      pageSizes,
    } = this.state;

    const rows = this.props.data;
    const columns = this.props.columns;
    const showFilter = this.props.showFilter;

    return (
      <Paper>
        <Grid rows={rows} columns={columns}>
          <FilteringState
            defaultFilters={defaultFilters}
            columnExtensions={filteringStateColumnExtensions}
          />
          <SortingState
            defaultSorting={defaultSorting}
            columnExtensions={sortingStateColumnExtensions}
          />
          {/* <SelectionState />  */}
          <GroupingState
            defaultGrouping={[{ columnName: "product" }]}
            // defaultExpandedGroups={['EnviroCare Max']}
          />
          <PagingState defaultCurrentPage={1} defaultPageSize={10} />
          {/* <IntegratedGrouping /> */}
          <IntegratedFiltering />
          <IntegratedSorting />
          <IntegratedPaging />
          {/* <IntegratedSelection /> */}
          {/* <DragDropProvider /> */}
          <Table columnExtensions={tableColumnExtensions} />
          {/* <TableColumnResizing columnExtensions={defaultColumnWidths}/> */}
          {/* <TableSelection showSelectAll={true} /> */}
          <TableHeaderRow
            showSortingControls={true}
            titleComponent={(props) =>
              props.children != "Action" ? (
                <b>{props.children}</b>
              ) : (
                <b>&emsp;{props.children}</b>
              )
            }
          />
          {showFilter ? <TableFilterRow showFilterSelector={true} /> : ""}
          <PagingPanel pageSizes={pageSizes} />
          {/* <Toolbar /> */}
        </Grid>
      </Paper>
    );
  }
}

R300DiscountVoucherTableComponent.propTypes = {
  showFilter: PropTypes.bool,
  data: PropTypes.array,
  columns: PropTypes.array,
};

R300DiscountVoucherTableComponent.defaultProps = {
  showFilter: false,
  data: [],
  columns: [],
};

export default R300DiscountVoucherTableComponent;
